import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import type { EnhancedRouteLocation } from './types'
import { useRouteCacheStore } from '@/stores' // , useUserStore

import { STORAGE_TOKEN_KEY } from '@/stores/mutation-type'
// import { isLogin } from '@/utils/auth'
// import setPageTitle from '@/utils/set-page-title'
// import { useEventBus } from '@vueuse/core'

NProgress.configure({ showSpinner: true, parent: '#app' })
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_PUBLIC_PATH),
  routes,
})

// This will update routes at runtime without reloading the page
if (import.meta.hot) handleHotUpdate(router)

router.beforeEach(async (to: EnhancedRouteLocation) => {
  NProgress.start()

  try {
    const routeCacheStore = useRouteCacheStore()
    // const userStore = useUserStore()

    // Route cache
    routeCacheStore.addRoute(to)

    // Set page title
    // setPageTitle(to.name)
    // setPageTitle()

    // 检查目标路由是否有效（不是404页面）
    const resolvedRoute = router.resolve(to.path)
    const isNotFoundRoute = resolvedRoute.name === '404'

    // 公共路由列表
    const publicRoutes = ['/', '/register', '/login']

    // 如果是404页面，直接允许导航
    if (isNotFoundRoute) {
      console.log('Navigating to 404 page, allowing navigation')
      return true
    }

    // 检查是否需要认证
    if (!publicRoutes.includes(to.path) && !localStorage.getItem(STORAGE_TOKEN_KEY)) {
      // 需要登录
      // const openLoginBus = useEventBus('open-login-popup')
      // openLoginBus.emit()
      // // console.log('publicRoutes - if - ')
      // return false
      return { path: '/', query: { refresh: Date.now().toString() } }
    } else {
      // console.log('publicRoutes - else - ')
    }
    // if (isLogin() && !userStore.userInfo?.uid) await userStore.info()
  } catch (error) {
    console.error('Router beforeEach error:', error)
    // 发生错误时重定向到首页，并添加时间戳参数以支持可能的刷新逻辑
    return { path: '/', query: { refresh: Date.now().toString() } }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
